import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { getCollectionAsync, getProductAsync, getProductVariantAsync, importMetafieldsIntoProductAsync } from './index';

const initialState = {
    isProductLoading: false,
    isError: false,
    products: [],
    pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: '',
        endCursor: ''
    },
    totalProductsCount: 0,
    isProductVariantLoading: false,
    productVariants: [],
    productVariantPageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: '',
        endCursor: ''
    },
    totalProductVariantsCount: 0,
    product: {
        title: '',
        image: '',
        status: '',
        variantCount: 0
    },
    isImportMetafieldsLoading: false,
    collection: {
        title: '',
        image: '',
        productsCount: 0
    },
    isCollectionLoading: false,
    collections: [],
    collectionPageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: '',
        endCursor: ''
    },
    totalCollectionCount: 0
}

const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        handleProduct(state, { payload }) {
            state.product = payload;
        },
        handleCollection(state, { payload }) {
            state.collection = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProductAsync.pending, (state) => {
                state.isProductLoading = true;
            })
            .addCase(getProductAsync.fulfilled, (state, { payload }) => {
                state.isProductLoading = false;
                state.products = payload.data;
                state.pageInfo = payload.pageInfo;
                state.totalProductsCount = payload.totalCount;
            })
            .addCase(getProductAsync.rejected, (state) => {
                state.isProductLoading = false;
                state.isError = false;
                state.products = [];
                state.pageInfo = {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    startCursor: '',
                    endCursor: ''
                };
                state.totalProductsCount = 0;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getCollectionAsync.pending, (state) => {
                state.isCollectionLoading = true;
            })
            .addCase(getCollectionAsync.fulfilled, (state, { payload }) => {
                state.isCollectionLoading = false;
                state.collections = payload.data?.collections || [];
                state.collectionPageInfo = payload.data?.pageInfo || {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    startCursor: '',
                    endCursor: ''
                };
                state.totalCollectionCount = payload.data?.totalCount || 0;
            })
            .addCase(getCollectionAsync.rejected, (state) => {
                state.isCollectionLoading = false;
                state.isError = false;
                state.collections = [];
                state.collectionPageInfo = {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    startCursor: '',
                    endCursor: ''
                };
                state.totalCollectionCount = 0;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getProductVariantAsync.pending, (state) => {
                state.isProductVariantLoading = true;
            })
            .addCase(getProductVariantAsync.fulfilled, (state, { payload }) => {
                state.isProductVariantLoading = false;
                state.productVariants = payload.data;
                state.productVariantPageInfo = payload.pageInfo;
                state.totalProductVariantsCount = payload.totalCount;
            })
            .addCase(getProductVariantAsync.rejected, (state) => {
                state.isProductVariantLoading = false;
                state.isError = false;
                state.productVariants = [];
                state.productVariantPageInfo = {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    startCursor: '',
                    endCursor: ''
                };
                state.totalProductVariantsCount = 0;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(importMetafieldsIntoProductAsync.pending, (state) => {
                state.isImportMetafieldsLoading = true;
            })
            .addCase(importMetafieldsIntoProductAsync.fulfilled, (state, { payload }) => {
                state.isImportMetafieldsLoading = false;
            })
            .addCase(importMetafieldsIntoProductAsync.rejected, (state) => {
                state.isImportMetafieldsLoading = false;
            });
    }
});

export const { handleProduct, handleCollection } = productSlice.actions;

export const getAllProducts = (state) => state.product;

export default productSlice.reducer;
